export default [
  {
    path: '/plans/landfill/list',
    name: 'plans.landfill.list',
    component: () => import('@/views/modules/plans/landfill-plan/ListLandfillsPlans'),
    meta: {
      module: 'plans.landfill',
      pageTitle: 'List Landfills Plans',
      breadcrumb: [
        { text: 'List Landfills Plans', active: true, },
        { text: 'Create Plan', to: {name: 'plans.landfill.create'} }
      ],
    }
  },


  {
    path: '/plans/landfill/create',
    name: 'plans.landfill.create',
    component: () => import('@/views/modules/plans/landfill-plan/CreateLandfillPlan'),
    meta: {
      module: 'plans.landfill',
      pageTitle: 'Create LandFill Plan',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.landfill.list'} },
        { text: 'Create Landfill Plan' , active: true}
      ],
    }
  },


  {
    path: '/plans/landfill/:id/edit',
    name: 'plans.landfill.edit',
    component: () => import('@/views/modules/plans/landfill-plan/EditLandfillPlan'),
    meta: {
      module: 'plans.landfill',
      pageTitle: 'Edit Landfill Plan',
      breadcrumb: [
        { text: 'List Landfills Plans', to: {name: 'plans.landfill.list'} },
        { text: 'Create Landfill Plan' , to: {name: 'plans.landfill.create'}},
        { text: 'Edit Plan' , active: true}
      ],
    }
  },
]
